export default __webpack_public_path__ + "static/media/fb1.0aa17590.svg";